import React from 'react';
import uniqBy from 'lodash/uniqBy';
import GuestExpansionPanel from './GuestExpansionPanel';

function BookerFields({ booker, cartItems, updateBookingGuest, user, defaultHotelId }) {
    const isAgent = user && user.role === 'agent';

    // booker fields needs to be collected for ALL tickets
    const bookerFields =
        cartItems &&
        uniqBy(
            cartItems
                .map(e =>
                    e.tickets
                        .filter(ticket => ticket.quantity > 0)
                        .map(ticket =>
                            ticket.booking_fields.filter(
                                ({ bookerOnly }) => bookerOnly === 'booker'
                            )
                        )
                )
                .flat(2),
            e => {
                return e.id;
            }
        );

    // Get first cart item with availabilityPk for FH lodging fields
    const firstCartItem = cartItems?.find(item => item.availabilityPk) || cartItems?.[0];

    return (
        <>
            {bookerFields.length > 0 && (
                <GuestExpansionPanel
                    isAgent={isAgent}
                    guest={booker}
                    guestLabel="Booker"
                    fields={bookerFields}
                    onGuestChange={updateBookingGuest}
                    activityId={firstCartItem?.activity_id}
                    availabilityPk={firstCartItem?.availabilityPk}
                    defaultHotelId={defaultHotelId}
                />
            )}
        </>
    );
}

export default BookerFields;
